import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { PopupProvider } from '@/context/PopupContext';
import { UniversalPopup } from '@/components/common/UniversalPopup';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { HomePage } from '@/pages/HomePage';
import { LandingPage } from '@/pages/LandingPage';
import { AboutPage } from '@/pages/AboutPage';
import { ContactPage } from '@/pages/ContactPage';
import { ServicePage } from '@/pages/ServicePage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicy';
import { TermsAndConditionsPage } from '@/pages/TermsAndConditions';
import { ApplicationPage } from '@/pages/ApplicationPage';
import { ServicesOverviewPage } from '@/pages/ServicesOverviewPage';
import { Toaster } from '@/components/ui/sonner';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const MainLayout = ({ children, isLandingPage = false }) => {
  return (
    <>
      <Navbar isLandingPage={isLandingPage} />
      {children}
      <Footer />
    </>
  );
};

const LandingPageLayout = ({ children }) => {
  return (
    <>
      <Navbar isLandingPage />
      {children}
    </>
  );
};

function App() {
  // LiveChat widget is now loaded via /assets/js/chat-script.js in index.html
  // No need for additional useEffect here

  return (
    <PopupProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
            <Route path="/lp" element={<LandingPageLayout><LandingPage /></LandingPageLayout>} />
            <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
            <Route path="/contact-us" element={<MainLayout><ContactPage /></MainLayout>} />
            <Route path="/services" element={<MainLayout><ServicesOverviewPage /></MainLayout>} />
            <Route path="/services/:category" element={<MainLayout><ServicePage /></MainLayout>} />
            <Route path="/services/:category/:service" element={<MainLayout><ServicePage /></MainLayout>} />
            <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicyPage /></MainLayout>} />
            <Route path="/terms-of-service" element={<MainLayout><TermsAndConditionsPage /></MainLayout>} />
            <Route path="/terms-and-conditions" element={<MainLayout><TermsAndConditionsPage /></MainLayout>} />
            <Route path="/application/main" element={<ApplicationPage />} />
          </Routes>
          <UniversalPopup />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </PopupProvider>
  );
}

export default App;